// constantesTablaContratos.tsx
import { Chip, Text } from "@mantine/core";
import type { IContrato } from "../../../modelos/Contratos/entidades/IContrato";
import type { ColumnDef } from "@tanstack/react-table";
import { TipoContratoColoresIconos, TipoContratoColors, TipoContratoIconos, type EnumTipoContrato } from "../enums/enumTipoContrato";
// import React from "react";

export const columnasTablaContrato = (): ColumnDef<IContrato>[] => [
  {
    accessorKey: "NumeroContrato",
    header: "Número Contrato",
    cell: ({ row }) => row.original.Numero,
  },
  {
    accessorKey: "TipoContrato",
    header: "Tipo Contrato",
    cell: ({ row }) => {
      const contrato = row.original as IContrato;
      const Icono = TipoContratoIconos[contrato.TipoContratoId as EnumTipoContrato];
      return (
        <Chip
          checked
          size="xs"
          readOnly
          icon={<Icono size={12} color={TipoContratoColoresIconos[contrato.TipoContratoId as EnumTipoContrato]} />}
          color={TipoContratoColors[contrato.TipoContratoId as EnumTipoContrato]}
        >
          <Text
            c={TipoContratoColoresIconos[contrato.TipoContratoId as EnumTipoContrato]}
            size="xs"
          >
            {contrato.TipoContrato?.Nombre || ''}
          </Text>
        </Chip>
      );
    },
  },
  {
    accessorKey: "FechaInicio",
    header: "Fecha Inicio",
    cell: ({ row }) => {
      const fecha = row.original.FechaInicio;

      if (!fecha) return "";

      const [yyyy, mm, dd] = fecha.split("T")[0].split("-");
      return `${dd}/${mm}/${yyyy}`;
    },
  },

  {
    accessorKey: "VigenciaMeses",
    header: "Vigencia",
    cell: ({ row }) => `${row.original.VigenciaMeses} Meses`,
  },
  {
    accessorKey: "FechaFin",
    header: "Fecha Fin",
    cell: ({ row }) => {
      const fecha = row.original.FechaInicio;

      if (!fecha) return "";

      const [yyyy, mm, dd] = fecha.split("T")[0].split("-");
      return `${dd}/${mm}/${yyyy}`;
    },
  },
  {
    accessorKey: "ValorMensual",
    header: "Valor Mensual",
    cell: ({ row }) =>
      `$ ${new Intl.NumberFormat("es-CO").format(row.original.ValorMensual ?? 0)}`,
  },
  {
    accessorKey: "CondicionesFacturacion",
    header: "Condiciones Facturación",
    cell: ({ row }) => row.original.CondicionesFacturacion,
  },
];
